import { appRoutes } from '../lib/routes';

export function AppErrorFallback() {
  return (
    <main className="min-h-screen flex items-center justify-center p-6">
      <div role="alert" className="card max-w-md p-8 text-center">
        <h1 className="font-display text-2xl mb-3">Die Seite konnte nicht geladen werden</h1>
        <p className="text-[var(--color-text-secondary)] mb-6">
          Bitte laden Sie die Seite neu oder kehren Sie zur Übersicht zurück.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Neu laden
          </button>
          <a className="btn btn-secondary" href={appRoutes.dashboard}>
            Zur Übersicht
          </a>
        </div>
      </div>
    </main>
  );
}
